export default __webpack_public_path__ + "static/media/p-7.311ce849.png";